export default __webpack_public_path__ + "static/media/CloseIconBlue.65d4929d.svg";